export const fileExport = (blob, filename, withOpen) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  const findFileName = filename?.match(/vnd\.openxmlformats-officedocument\.\w+/)?.[0];

  switch (findFileName) {
    case 'vnd.openxmlformats-officedocument.wordprocessingml':
      a.download = filename.replace(findFileName + '.document', '') + 'docx';
      break;

    case 'vnd.openxmlformats-officedocument.presentationml':
      a.download = filename.replace(findFileName + '.presentation', '') + 'pptx';
      break;

    case 'vnd.openxmlformats-officedocument.spreadsheetml':
      a.download = filename.replace(findFileName + '.sheet', '') + 'xlsx';
      break;

    default:
      a.download = filename;
      break;
  }

  if (withOpen) {
    window.open(url, '_blank');
  }

  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};
